module.exports = __webpack_public_path__ + "static/media/laravel.27332260.svg";